import { camelizeKeys } from "humps";
import { ORDERS_URL } from "api_urls";
import { checkStatus, getRequest, parseJSON, postRequest, } from "helpers/ajax_request";
export function calculateTotals(storePrettyUrl, orderDraft) {
    return fetch(ORDERS_URL + "/" + storePrettyUrl + "/cart/calculate", postRequest(orderDraft))
        .then(checkStatus)
        .then(parseJSON)
        .then(camelizeKeys);
}
export function getGiftCardBalance(giftCardInfo) {
    var balanceUrl = ORDERS_URL + "/gift_cards/balance?balance_request_id=" + giftCardInfo.requestId + "&gift_code=" + giftCardInfo.giftCode + "&pin=" + giftCardInfo.pin + "&store_pretty_url=" + giftCardInfo.storePrettyUrl;
    return fetch(balanceUrl, getRequest())
        .then(checkStatus)
        .then(parseJSON)
        .then(camelizeKeys);
}
